export default class FoundationComponents {
  initializeListeners() {
    $(document).foundation();
  }
}
